import { useQuery } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { projectConfigs } from '@/shared/config/projects';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useGetLanguages() {
  const project = useCurrentProject();
  return useQuery({
    queryKey: [project, 'languages'],
    initialData: {
      languages: [],
    },
    queryFn: Api.languages.getLanguages,
    enabled: projectConfigs[project].capabilities.languages,
  });
}
